/**
 * Created by asiulik on 26.09.2018.
 */

define([], function(){

    function Tracking(){
    }

    Tracking.prototype.trackAction = function(trackObj){

        this.trackGTM(trackObj);
        // this.trackGA(trackObj);

    };

    Tracking.prototype.trackGTM = function(trackObj){

        try {
            window.dataLayer.push(trackObj);
        } catch(e){
            console.log('track gtm problem')
        }

    };

    Tracking.prototype.trackGA = function(trackArr){
        try {
            window.ga.apply(window.ga, trackArr);
        } catch(e){
            console.log('track gtm problem')
        }

    };

    return Tracking;

});



// WEBPACK FOOTER //
// ./Private/Scripts/core/tracking.js